import { ArrowLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { cn } from '../lib/utils';

export interface PosBackButtonProps {
  onClick: () => void;
  /** Accessible label; defaults to `pos.back` (Retour / Back). */
  label?: string;
  className?: string;
  /** `default` = kiosk touch target; `compact` for denser headers. */
  size?: 'default' | 'compact';
}

/**
 * POS kiosk back control — always place top-left of the screen content
 * (below PosTopBar). Root selling and success screens are exceptions (no back).
 */
export function PosBackButton({
  onClick,
  label,
  className,
  size = 'default',
}: PosBackButtonProps) {
  const { t } = useTranslation();
  const aria = label ?? t('pos.back');

  return (
    <button
      type="button"
      onClick={onClick}
      title={aria}
      aria-label={aria}
      className={cn(
        'rounded-lg bg-gray-800 hover:bg-gray-700 flex items-center justify-center text-gray-400 hover:text-white transition-colors shrink-0',
        size === 'default'
          ? 'w-10 h-10 min-h-[40px] min-w-[40px] xl:w-11 xl:h-11'
          : 'w-8 h-8',
        className,
      )}
    >
      <ArrowLeft size={size === 'default' ? 16 : 15} />
    </button>
  );
}
